export default __webpack_public_path__ + "static/media/lock_icon_24m.4fd7dc90.png";